import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import AnnouncementForm from './AnnouncementForm';
import AnnouncementList from './AnnouncementList';
import MembersList from './MembersList';
import MessageList from './MessageList';
import UsersList from './UsersList';
import { API_URL } from '../config';
import {
  Megaphone, Mail, Users, FileText, Plus, MessageSquare, User, Settings,
  LogOut, ArrowLeft, Loader2, Shield, UserPlus, Calendar, Image, Trash2, X, Save,
  // Tüm Lucide İkonları - Kategorilere göre
  Activity, Airplay, AlertCircle, AlertOctagon, AlertTriangle, AlignCenter,
  AlignJustify, AlignLeft, AlignRight, Anchor, Aperture, Archive, ArrowDown,
  ArrowDownCircle, ArrowDownLeft, ArrowDownRight, ArrowLeftCircle, ArrowRight,
  ArrowRightCircle, ArrowUp, ArrowUpCircle, ArrowUpDown, ArrowUpLeft, ArrowUpRight,
  AtSign, Award, BarChart, BarChart2, BarChart3, Battery, BatteryCharging,
  Bell, BellOff, Bluetooth, Bold, Book, BookOpen, Bookmark, Box, Briefcase,
  Building, Building2, Cake, Calculator, Camera, CameraOff, Car,
  Cast, Check, CheckCircle, CheckSquare, ChevronDown, ChevronLeft, ChevronRight,
  ChevronUp, Chrome, Circle, Clipboard, Clock, Cloud, CloudOff, CloudRain,
  CloudSnow, Code, Code2, Codepen, Coffee, Cog, Coins, Columns, Command,
  Compass, Component, Computer, Contact, Copy, CreditCard, Crop, Crown,
  Database, Delete, Diamond, Dice1, Dice2, Dice3, Dice4, Dice5, Dice6,
  Disc, DollarSign, Download, Droplet, Edit, Edit2, Edit3, Egg, Equal,
  Eraser, Euro, ExternalLink, Eye, EyeOff, Facebook, FastForward, Feather,
  File, FileCheck, FileCode, FileMinus, FilePlus, FileText as FileTextIcon, FileX, Film, Filter,
  Flag, Flame, Flashlight, Folder, FolderMinus, FolderOpen, FolderPlus,
  Forward, Frame, Frown, Fuel, Gamepad, Gamepad2, Gauge, Gavel, Gem, Ghost,
  Gift, GitBranch, GitCommit, GitMerge, GitPullRequest, Github, Gitlab,
  Globe, Globe2, GraduationCap, Grip, GripHorizontal, GripVertical,
  Hammer, Hand, HardDrive, Hash, Headphones, Heart, HeartOff, HelpCircle,
  Hexagon, Highlighter, History, Home, Hourglass, IceCream, Inbox,
  Infinity, Info, Instagram, Italic, Key, Keyboard, Lamp, Landmark,
  Languages, Laptop, Laptop2, Layers, Layout, LayoutDashboard, LayoutGrid,
  LayoutList, Leaf, Library, LifeBuoy, Lightbulb, Link, Link2, Linkedin,
  List, ListChecks, ListMinus, ListOrdered, ListPlus, Loader, Locate,
  Lock, LogIn, Luggage, Magnet, MailCheck, MailMinus, MailOpen,
  MailPlus, MailQuestion, MailWarning, MailX, Map, MapPin, Maximize,
  Maximize2, Medal, Megaphone as MegaphoneIcon, Meh, Menu, Merge, MessageCircle,
  Mic, MicOff, Milk, Minimize, Minimize2, Minus, MinusCircle, MinusSquare,
  Monitor, Moon, MoreHorizontal, MoreVertical, Mountain, Mouse, MousePointer,
  Move, Music, Music2, Music3, Music4, Navigation, Navigation2, Network,
  Newspaper, Octagon, Option, Package, Paintbrush, Palette, Paperclip,
  Pause, PauseCircle, PenTool, Pencil, Percent, PersonStanding, Phone,
  PhoneCall, PhoneForwarded, PhoneIncoming, PhoneMissed, PhoneOff,
  PhoneOutgoing, PieChart, Pin, PinOff, Pizza, Plane, Play, PlayCircle,
  Plug, PlusCircle, PlusSquare, Pocket, Podcast, Pointer, Power,
  Presentation, Printer, Puzzle, QrCode, Quote, Radio, RadioReceiver,
  Receipt, RefreshCcw, RefreshCw, Regex, Repeat, Reply, Rewind, Rocket,
  RotateCcw, RotateCw, Rss, Ruler, Save as SaveIcon, Scale, Scan, ScanLine, Scissors,
  ScreenShare, ScreenShareOff, Search, Send, Server, ServerOff,
  Share, Share2, Sheet, Shield as ShieldIcon, ShieldAlert, ShieldCheck, ShieldOff,
  Ship, Shirt, ShoppingBag, ShoppingCart, Shovel, Shrink, Shuffle, Sidebar,
  Signal, SignalHigh, SignalLow, SignalMedium, SignalZero, Siren, SkipBack,
  SkipForward, Skull, Slack, Slash, Sliders, Smartphone, Smile, Snowflake,
  SortAsc, SortDesc, Sparkle, Sparkles, Speaker, Spline, Split, Spray,
  Square, Star, StickyNote, StopCircle, Store, StretchHorizontal,
  StretchVertical, Strikethrough, Subscript, Sun, SunDim, SunMedium,
  SunMoon, Sunrise, Sunset, Superscript, SwissFranc, SwitchCamera,
  Sword, Swords, Table, Table2, Tablet, Tag, Tags, Target, Tent, Terminal,
  TerminalSquare, TestTube, TestTube2, TestTubes, Text, TextCursor,
  Thermometer, ThumbsDown, ThumbsUp, Ticket, Timer, TimerOff, TimerReset,
  ToggleLeft, ToggleRight, Tornado, Trash, TreeDeciduous, TreePine, Trees,
  Trello, TrendingDown, TrendingUp, Triangle, Trophy, Truck, Tv, Tv2,
  Twitch, Twitter, Type, Umbrella, Underline, Undo, Undo2, Unlink, Unlink2,
  Unlock, Upload, UploadCloud, Usb, UserCheck, UserMinus, UserX,
  Utensils, Variable, Video, VideoOff, View, Voicemail, Volume,
  Volume1, Volume2, VolumeX, Wallet, Wand, Wand2, Watch, Waves,
  Webcam, Webhook, Wifi, WifiOff, Wind, Wine, Wrench, XCircle, XOctagon,
  XSquare, Youtube, Zap, ZapOff, ZoomIn, ZoomOut
} from 'lucide-react';

function AdminPanel({ isLoggedIn, userRole, setIsLoggedIn, setUserRole }) {
  const [view, setView] = useState('menu');
  const [announcements, setAnnouncements] = useState([]);
  const [messages, setMessages] = useState([]);
  const [members, setMembers] = useState([]);
  const [pastEvents, setPastEvents] = useState([]);
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);
  const [memberSearchQuery, setMemberSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [stats, setStats] = useState({ announcements: 0, messages: 0, members: 0, pastEvents: 0, pendingCount: 0 });
  const [pendingItems, setPendingItems] = useState({ announcements: [], events: [] });
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('adminTheme') !== 'light');

  // Tema değişikliğini kaydet
  useEffect(() => {
    localStorage.setItem('adminTheme', darkMode ? 'dark' : 'light');
  }, [darkMode]);

  // Tema renkleri
  const theme = darkMode ? {
    bg: 'bg-[#0f1419]',
    card: 'bg-[#1a1f2e]',
    cardHover: 'hover:bg-[#252d3d]',
    border: 'border-[#2a3441]',
    text: 'text-gray-100',
    textSecondary: 'text-gray-400',
    textMuted: 'text-gray-500',
    input: 'bg-[#1a1f2e] border-[#2a3441]',
    accent: 'bg-indigo-600 hover:bg-indigo-700',
    accentText: 'text-indigo-400'
  } : {
    bg: 'bg-[#e3eef7]',
    card: 'bg-[#d4e5f2]',
    cardHover: 'hover:bg-[#c5daea]',
    border: 'border-[#a8c9e0]',
    text: 'text-[#1e3a52]',
    textSecondary: 'text-[#456b8a]',
    textMuted: 'text-[#6a92b3]',
    input: 'bg-[#d4e5f2] border-[#a8c9e0]',
    accent: 'bg-sky-500 hover:bg-sky-600',
    accentText: 'text-sky-600'
  };

  const token = localStorage.getItem('token');
  const navigate = useNavigate();

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsLoggedIn(false);
    setUserRole(null);
    navigate('/login');
  };

  const loadStats = useCallback(async () => {
    try {
      const fetchPromises = [
        fetch(API_URL + '/api/duyurular'),
        fetch(API_URL + '/api/messages'),
        fetch(API_URL + '/api/members'),
        fetch(API_URL + '/api/past-events')
      ];

      // Super user ise pending içerikleri de çek
      if (userRole === 'super_user') {
        fetchPromises.push(
          fetch(API_URL + '/api/duyurular/pending', {
            headers: { Authorization: `Bearer ${token}` }
          }),
          fetch(API_URL + '/api/past-events?pending=true', {
            headers: { Authorization: `Bearer ${token}` }
          })
        );
      }

      const responses = await Promise.all(fetchPromises);
      const [announcementsRes, messagesRes, membersRes, pastEventsRes] = responses;

      const announcementsData = await announcementsRes.json();
      const messagesData = await messagesRes.json();
      const membersData = await membersRes.json();
      const pastEventsData = await pastEventsRes.json();

      let pendingAnnouncements = [];
      let pendingEvents = [];

      if (userRole === 'super_user' && responses.length > 4) {
        pendingAnnouncements = await responses[4].json();
        pendingEvents = await responses[5].json();
        setPendingItems({
          announcements: Array.isArray(pendingAnnouncements) ? pendingAnnouncements : [],
          events: Array.isArray(pendingEvents) ? pendingEvents : []
        });
      }

      const pendingCount = (Array.isArray(pendingAnnouncements) ? pendingAnnouncements.length : 0) +
        (Array.isArray(pendingEvents) ? pendingEvents.length : 0);

      setStats({
        announcements: Array.isArray(announcementsData) ? announcementsData.length : 0,
        messages: Array.isArray(messagesData) ? messagesData.length : 0,
        members: Array.isArray(membersData) ? membersData.length : 0,
        pastEvents: Array.isArray(pastEventsData) ? pastEventsData.length : 0,
        pendingCount
      });
      setAnnouncements(Array.isArray(announcementsData) ? announcementsData : []);
    } catch (error) {
      console.error('İstatistikler yüklenirken hata:', error);
    }
  }, [userRole, token]);

  useEffect(() => { loadStats(); }, [loadStats]);

  const handleFormSubmit = async (formData) => {
    setLoading(true);
    try {
      const jsonData = {};
      formData.forEach((value, key) => { jsonData[key] = value; });
      const response = await fetch(API_URL + '/api/duyurular', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(jsonData),
      });
      if (!response.ok) throw new Error('Duyuru eklenemedi');
      const addedAnnouncement = await response.json();
      setAnnouncements([addedAnnouncement, ...announcements]);
      setView('menu');
      loadStats();
    } catch (error) {
      console.error('Duyuru eklenirken hata:', error);
      alert('Duyuru eklenirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteAnnouncement = async (id) => {
    if (!window.confirm('Bu duyuruyu silmek istediğinize emin misiniz?')) return;
    setLoading(true);
    try {
      const response = await fetch(API_URL + `/api/duyurular/${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.ok) throw new Error('Duyuru silinemedi');
      setAnnouncements(announcements.filter(a => a.id !== id));
      loadStats();
    } catch (error) {
      console.error('Duyuru silinirken hata:', error);
      alert('Duyuru silinirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  const handleViewMessagesClick = async () => {
    setLoading(true);
    try {
      const response = await fetch(API_URL + '/api/messages');
      const data = await response.json();
      setMessages(Array.isArray(data) ? data : []);
      setView('messages');
    } catch (error) {
      console.error('Mesajlar alınırken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteMessage = async (id) => {
    if (!window.confirm('Bu mesajı silmek istediğinize emin misiniz?')) return;
    setLoading(true);
    try {
      const response = await fetch(API_URL + `/api/messages?id=${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error('Mesaj silinemedi');
      setMessages(messages.filter(m => m.id !== id));
      loadStats();
    } catch (error) {
      console.error('Mesaj silinirken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  // Üyeleri sessizce yenile (canlı senkronizasyon için)
  const refreshMembers = useCallback(async () => {
    try {
      const response = await fetch(API_URL + '/api/members');
      const data = await response.json();
      setMembers(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error('Üyeler yenilenirken hata:', error);
    }
  }, []);

  const handleViewMembersClick = async () => {
    setLoading(true);
    try {
      const response = await fetch(API_URL + '/api/members');
      const data = await response.json();
      setMembers(Array.isArray(data) ? data : []);
      setView('members');
    } catch (error) {
      console.error('Üyeler alınırken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteMember = async (id) => {
    if (!window.confirm('Bu üyeyi silmek istediğinize emin misiniz?')) return;
    setLoading(true);
    try {
      const response = await fetch(API_URL + `/api/members?id=${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error('Üye silinemedi');
      setMembers(members.filter(m => m.id !== id));
      loadStats();
    } catch (error) {
      console.error('Üye silinirken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddClick = () => { setSelectedAnnouncement(null); setView('form'); };
  const handleViewListClick = () => setView('list');
  const handleBackToMenu = () => setView('menu');
  const handleViewUsersClick = () => setView('users');
  const handleAddUserClick = () => setView('addUser');
  const handleAddMemberClick = () => setView('addMember');
  const handleViewPendingClick = () => setView('pending');

  // Onaylama/Reddetme fonksiyonları
  const handleApproveItem = async (type, id, updatedData = null) => {
    setLoading(true);
    try {
      const url = type === 'announcement'
        ? `${API_URL}/api/duyurular/${id}/approve`
        : `${API_URL}/api/past-events?id=${id}`;

      const response = await fetch(url, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ status: 'approved', ...updatedData })
      });

      if (response.ok) {
        loadStats();
        alert('İçerik onaylandı!');
      }
    } catch (error) {
      console.error('Onaylama hatası:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleRejectItem = async (type, id) => {
    if (!window.confirm('Bu içeriği reddetmek istediğinize emin misiniz?')) return;
    setLoading(true);
    try {
      const url = type === 'announcement'
        ? `${API_URL}/api/duyurular/${id}/approve`
        : `${API_URL}/api/past-events?id=${id}`;

      const response = await fetch(url, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ status: 'rejected' })
      });

      if (response.ok) {
        loadStats();
        alert('İçerik reddedildi.');
      }
    } catch (error) {
      console.error('Reddetme hatası:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewPastEventsClick = async () => {
    setLoading(true);
    try {
      const response = await fetch(API_URL + '/api/past-events');
      const data = await response.json();
      setPastEvents(Array.isArray(data) ? data : []);
      setView('pastEvents');
    } catch (error) {
      console.error('Geçmiş etkinlikler alınırken hata:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleAddPastEventClick = () => setView('addPastEvent');

  const handleDeletePastEvent = async (id) => {
    if (!window.confirm('Bu etkinliği silmek istediğinize emin misiniz?')) return;
    setLoading(true);
    try {
      const response = await fetch(API_URL + `/api/past-events?id=${id}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!response.ok) throw new Error('Etkinlik silinemedi');
      setPastEvents(pastEvents.filter(e => e.id !== id));
      loadStats();
    } catch (error) {
      console.error('Etkinlik silinirken hata:', error);
    } finally {
      setLoading(false);
    }
  };

  const LoadingOverlay = () => (
    loading && (
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50">
        <div className="bg-zinc-900 border border-zinc-700 rounded-lg p-6 flex flex-col items-center gap-3">
          <Loader2 className="w-8 h-8 text-violet-500 animate-spin" />
          <p className="text-zinc-300 text-sm">İşlem yapılıyor...</p>
        </div>
      </div>
    )
  );

  const StatCard = ({ icon: Icon, title, value, onClick }) => (
    <button onClick={onClick} className={`${theme.card} border ${theme.border} rounded-xl p-4 ${theme.cardHover} hover:border-indigo-500/30 transition-all text-left w-full group shadow-sm`}>
      <div className="flex items-center justify-between">
        <div>
          <p className={`${theme.textMuted} text-xs uppercase tracking-wide font-medium`}>{title}</p>
          <p className={`text-2xl font-bold ${theme.text} mt-1`}>{value}</p>
        </div>
        <div className={`w-10 h-10 rounded-xl ${darkMode ? 'bg-gray-800/50' : 'bg-gray-100'} flex items-center justify-center group-hover:bg-indigo-500/20 transition-colors`}>
          <Icon className={`w-5 h-5 ${darkMode ? 'text-gray-400 group-hover:text-indigo-400' : 'text-gray-500 group-hover:text-indigo-500'} transition-colors`} />
        </div>
      </div>
    </button>
  );

  const MenuCard = ({ icon: Icon, title, description, onClick, badge }) => (
    <button onClick={onClick} className={`${theme.card} border ${theme.border} rounded-xl p-4 ${theme.cardHover} hover:border-indigo-500/50 transition-all text-left w-full group relative shadow-sm`}>
      {badge > 0 && (
        <span className="absolute -top-2 -right-2 w-5 h-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center font-medium">
          {badge}
        </span>
      )}
      <div className="flex items-center gap-3">
        <div className={`w-11 h-11 rounded-xl ${darkMode ? 'bg-gray-800/50' : 'bg-gray-100'} flex items-center justify-center group-hover:bg-indigo-500/20 transition-colors`}>
          <Icon className={`w-5 h-5 ${darkMode ? 'text-gray-400 group-hover:text-indigo-400' : 'text-gray-500 group-hover:text-indigo-500'} transition-colors`} />
        </div>
        <div>
          <h3 className={`text-sm font-medium ${theme.text}`}>{title}</h3>
          <p className={`text-xs ${theme.textMuted} mt-0.5`}>{description}</p>
        </div>
      </div>
    </button>
  );

  return (
    <div className={`min-h-screen ${theme.bg} pt-28 pb-8 px-4 transition-colors duration-300`}>
      <LoadingOverlay />

      {view === 'menu' && (
        <div className="max-w-5xl mx-auto">
          {/* Header */}
          <div className={`${theme.card} border ${theme.border} rounded-2xl p-6 mb-6 shadow-lg`}>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className={`w-14 h-14 rounded-2xl ${userRole === 'super_user' ? 'bg-gradient-to-br from-amber-500 to-orange-600' : (darkMode ? 'bg-gradient-to-br from-indigo-500 to-purple-600' : 'bg-gradient-to-br from-sky-400 to-blue-500')} flex items-center justify-center shadow-lg`}>
                  {userRole === 'super_user' ? <Crown className="w-7 h-7 text-white" /> : <Shield className="w-7 h-7 text-white" />}
                </div>
                <div>
                  <h1 className={`text-2xl font-bold ${theme.text}`}>Admin Panel</h1>
                  <div className="flex items-center gap-2 mt-1">
                    <span className={`text-sm ${userRole === 'super_user' ? 'text-amber-500' : theme.textSecondary}`}>
                      {userRole === 'super_user' ? '👑 Süper Yönetici' : '🛡️ Yönetici'}
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-3">
                {/* Tema Toggle */}
                <button
                  onClick={() => setDarkMode(!darkMode)}
                  className={`p-3 ${theme.card} border ${theme.border} rounded-xl ${theme.cardHover} transition-all`}
                  title={darkMode ? 'Açık Tema' : 'Koyu Tema'}
                >
                  {darkMode ? <Sun className="w-5 h-5 text-amber-400" /> : <Moon className="w-5 h-5 text-sky-500" />}
                </button>
                <button
                  onClick={handleLogout}
                  className={`flex items-center gap-2 px-4 py-2.5 ${theme.card} border ${theme.border} rounded-xl ${theme.textSecondary} hover:text-red-500 hover:border-red-500/50 transition-all text-sm font-medium`}
                >
                  <LogOut className="w-4 h-4" /> Çıkış
                </button>
              </div>
            </div>
          </div>

          {/* Stats Cards */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
            <StatCard icon={Megaphone} title="Duyuru" value={stats.announcements} onClick={handleViewListClick} />
            <StatCard icon={Mail} title="Mesaj" value={stats.messages} onClick={handleViewMessagesClick} />
            <StatCard icon={Users} title="Üye" value={stats.members} onClick={handleViewMembersClick} />
            <StatCard icon={Calendar} title="Etkinlik" value={stats.pastEvents} onClick={handleViewPastEventsClick} />
          </div>

          {/* Super User - Onay Bekleyenler Banner */}
          {userRole === 'super_user' && stats.pendingCount > 0 && (
            <button
              onClick={handleViewPendingClick}
              className="w-full mb-6 p-4 bg-gradient-to-r from-amber-500/20 to-orange-500/20 border border-amber-500/30 rounded-xl flex items-center justify-between hover:from-amber-500/30 hover:to-orange-500/30 transition-all group"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-amber-500/20 rounded-xl flex items-center justify-center">
                  <Clock className="w-5 h-5 text-amber-500" />
                </div>
                <div className="text-left">
                  <p className="text-amber-500 font-semibold">{stats.pendingCount} içerik onay bekliyor</p>
                  <p className={`text-sm ${theme.textMuted}`}>Duyuru ve etkinlik onayları</p>
                </div>
              </div>
              <ChevronRight className="w-5 h-5 text-amber-500 group-hover:translate-x-1 transition-transform" />
            </button>
          )}

          {/* Menu Grid */}
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
            <MenuCard icon={FileText} title="Duyurular" description="Görüntüle, düzenle, sil" onClick={handleViewListClick} />
            <MenuCard icon={Plus} title="Yeni Duyuru" description="Duyuru oluştur" onClick={handleAddClick} />
            <MenuCard icon={MessageSquare} title="Mesajlar" description="İletişim mesajları" onClick={handleViewMessagesClick} />
            <MenuCard icon={User} title="Üyeler" description="Kayıtlı üyeler" onClick={handleViewMembersClick} />
            <MenuCard icon={Calendar} title="Etkinlik Galerisi" description="Geçmiş etkinlikleri görüntüle" onClick={handleViewPastEventsClick} />
            <MenuCard icon={Image} title="Etkinlik Ekle" description="Galeriye etkinlik ekle" onClick={handleAddPastEventClick} />
            {userRole === 'super_user' && (
              <>
                <MenuCard icon={Clock} title="Onay Bekleyenler" description="İçerik onayları" onClick={handleViewPendingClick} badge={stats.pendingCount} />
                <MenuCard icon={Settings} title="Yöneticiler" description="Yönetici listesi" onClick={handleViewUsersClick} />
                <MenuCard icon={UserPlus} title="Yönetici Ekle" description="Yeni yönetici oluştur" onClick={handleAddUserClick} />
              </>
            )}
          </div>
        </div>
      )}

      {/* Onay Bekleyenler Sayfası */}
      {view === 'pending' && (
        <div className="max-w-5xl mx-auto">
          <div className="flex items-center gap-3 mb-6">
            <button onClick={handleBackToMenu} className={`p-2 ${theme.cardHover} rounded-xl transition-colors`}>
              <ArrowLeft className={`w-5 h-5 ${theme.textSecondary}`} />
            </button>
            <div>
              <h2 className={`text-xl font-bold ${theme.text}`}>Onay Bekleyenler</h2>
              <p className={`text-sm ${theme.textMuted}`}>{stats.pendingCount} içerik bekliyor</p>
            </div>
          </div>

          {/* Bekleyen Duyurular */}
          {pendingItems.announcements.length > 0 && (
            <div className="mb-8">
              <h3 className={`text-lg font-semibold ${theme.text} mb-4 flex items-center gap-2`}>
                <Megaphone className="w-5 h-5 text-indigo-500" /> Duyurular
              </h3>
              <div className="space-y-4">
                {pendingItems.announcements.map(item => (
                  <div key={item.id} className={`${theme.card} border ${theme.border} rounded-xl p-5 shadow-sm`}>
                    <div className="flex items-start justify-between gap-4">
                      <div className="flex-1">
                        <div className="flex items-center gap-2 mb-2">
                          <span className="px-2 py-0.5 bg-amber-500/20 text-amber-500 text-xs font-medium rounded-full">Bekliyor</span>
                          <span className={`text-xs ${theme.textMuted}`}>Gönderen: {item.submittedBy}</span>
                        </div>
                        <h4 className={`font-semibold ${theme.text} mb-1`}>{item.title}</h4>
                        <p className={`text-sm ${theme.textSecondary} line-clamp-2`}>{item.shortDetail}</p>
                      </div>
                      {item.cardImage && (
                        <img src={item.cardImage} alt="" className="w-20 h-20 object-cover rounded-lg" />
                      )}
                    </div>
                    <div className="flex items-center gap-2 mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
                      <button
                        onClick={() => handleApproveItem('announcement', item.id)}
                        className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white text-sm rounded-lg transition-colors"
                      >
                        <Check className="w-4 h-4" /> Onayla
                      </button>
                      <button
                        onClick={() => handleRejectItem('announcement', item.id)}
                        className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-red-600 hover:bg-red-700 text-white text-sm rounded-lg transition-colors"
                      >
                        <X className="w-4 h-4" /> Reddet
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Bekleyen Etkinlikler */}
          {pendingItems.events.length > 0 && (
            <div>
              <h3 className={`text-lg font-semibold ${theme.text} mb-4 flex items-center gap-2`}>
                <Calendar className="w-5 h-5 text-indigo-500" /> Etkinlikler
              </h3>
              <div className="space-y-4">
                {pendingItems.events.map(item => (
                  <div key={item.id} className={`${theme.card} border ${theme.border} rounded-xl p-5 shadow-sm`}>
                    <div className="flex items-start justify-between gap-4">
                      <div className="flex items-start gap-3">
                        <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${item.color} flex items-center justify-center text-white`}>
                          <Star className="w-6 h-6" />
                        </div>
                        <div>
                          <div className="flex items-center gap-2 mb-1">
                            <span className="px-2 py-0.5 bg-amber-500/20 text-amber-500 text-xs font-medium rounded-full">Bekliyor</span>
                            <span className={`text-xs ${theme.textMuted}`}>Gönderen: {item.submittedBy}</span>
                          </div>
                          <h4 className={`font-semibold ${theme.text}`}>{item.title}</h4>
                          <p className={`text-sm ${theme.textSecondary} line-clamp-2`}>{item.description}</p>
                        </div>
                      </div>
                    </div>
                    {item.images && item.images.length > 0 && (
                      <div className="flex gap-2 mt-3">
                        {item.images.slice(0, 3).map((img, idx) => (
                          <img key={idx} src={img.src} alt="" className="w-16 h-16 object-cover rounded-lg" />
                        ))}
                      </div>
                    )}
                    <div className="flex items-center gap-2 mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
                      <button
                        onClick={() => handleApproveItem('event', item.id)}
                        className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white text-sm rounded-lg transition-colors"
                      >
                        <Check className="w-4 h-4" /> Onayla
                      </button>
                      <button
                        onClick={() => handleRejectItem('event', item.id)}
                        className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-red-600 hover:bg-red-700 text-white text-sm rounded-lg transition-colors"
                      >
                        <X className="w-4 h-4" /> Reddet
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {pendingItems.announcements.length === 0 && pendingItems.events.length === 0 && (
            <div className={`${theme.card} border ${theme.border} rounded-xl p-12 text-center`}>
              <CheckCircle className="w-16 h-16 text-emerald-500 mx-auto mb-4" />
              <h3 className={`text-lg font-semibold ${theme.text} mb-2`}>Tüm içerikler onaylandı!</h3>
              <p className={`${theme.textMuted}`}>Şu anda bekleyen içerik bulunmuyor.</p>
            </div>
          )}
        </div>
      )}

      {view === 'list' && (
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-3">
              <button onClick={handleBackToMenu} className={`p-2 ${theme.cardHover} rounded-lg transition-colors`}>
                <ArrowLeft className={`w-5 h-5 ${theme.textSecondary}`} />
              </button>
              <h2 className={`text-lg font-medium ${theme.text}`}>Duyurular</h2>
            </div>
            <button onClick={handleAddClick} className="flex items-center gap-2 px-3 py-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm rounded-lg transition-colors">
              <Plus className="w-4 h-4" /> Ekle
            </button>
          </div>
          <AnnouncementList announcements={announcements} onEdit={(a) => { setSelectedAnnouncement(a); setView('form'); }} onDelete={handleDeleteAnnouncement} />
        </div>
      )}

      {view === 'form' && (
        <div className="max-w-2xl mx-auto">
          <div className="flex items-center gap-3 mb-4">
            <button onClick={handleBackToMenu} className={`p-2 ${theme.cardHover} rounded-lg transition-colors`}>
              <ArrowLeft className={`w-5 h-5 ${theme.textSecondary}`} />
            </button>
            <h2 className={`text-lg font-medium ${theme.text}`}>{selectedAnnouncement ? 'Duyuru Düzenle' : 'Yeni Duyuru'}</h2>
          </div>
          <AnnouncementForm announcement={selectedAnnouncement} onSave={handleFormSubmit} onCancel={handleBackToMenu} userRole={userRole} />
        </div>
      )}

      {view === 'messages' && (
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center gap-3 mb-4">
            <button onClick={handleBackToMenu} className={`p-2 ${theme.cardHover} rounded-lg transition-colors`}>
              <ArrowLeft className={`w-5 h-5 ${theme.textSecondary}`} />
            </button>
            <h2 className={`text-lg font-medium ${theme.text}`}>Mesajlar</h2>
          </div>
          <MessageList messages={messages} onDelete={handleDeleteMessage} />
        </div>
      )}

      {view === 'members' && (
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-3">
              <button onClick={handleBackToMenu} className={`p-2 ${theme.cardHover} rounded-lg transition-colors`}>
                <ArrowLeft className={`w-5 h-5 ${theme.textSecondary}`} />
              </button>
              <h2 className={`text-lg font-medium ${theme.text}`}>Üyeler</h2>
            </div>
            <button onClick={handleAddMemberClick} className="flex items-center gap-2 px-3 py-2 bg-emerald-600 hover:bg-emerald-700 text-white text-sm rounded-lg transition-colors">
              <UserPlus className="w-4 h-4" /> Üye Ekle
            </button>
          </div>

          {/* Arama */}
          <div className="mb-4">
            <div className="relative">
              <Search className={`absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 ${theme.textMuted}`} />
              <input
                type="text"
                value={memberSearchQuery}
                onChange={(e) => setMemberSearchQuery(e.target.value)}
                placeholder="İsim, e-posta veya bölüm ara..."
                className={`w-full pl-10 pr-4 py-2.5 ${theme.card} border ${theme.border} rounded-lg ${theme.text} text-sm focus:outline-none focus:border-emerald-500 transition-colors ${darkMode ? 'placeholder:text-gray-600' : 'placeholder:text-gray-400'}`}
              />
              {memberSearchQuery && (
                <button
                  onClick={() => setMemberSearchQuery('')}
                  className={`absolute right-3 top-1/2 -translate-y-1/2 p-1 ${theme.textMuted} ${darkMode ? 'hover:text-white' : 'hover:text-gray-900'} transition-colors`}
                >
                  <X className="w-4 h-4" />
                </button>
              )}
            </div>
          </div>

          <MembersList
            members={members.filter(m => {
              if (!memberSearchQuery.trim()) return true;
              const query = memberSearchQuery.toLowerCase();
              return (
                m.fullName?.toLowerCase().includes(query) ||
                m.email?.toLowerCase().includes(query) ||
                m.department?.toLowerCase().includes(query) ||
                m.schoolNumber?.toLowerCase().includes(query)
              );
            })}
            onDelete={handleDeleteMember}
            onUpdate={(memberId, field, value) => {
              setMembers(members.map(m =>
                m.id === memberId ? { ...m, [field]: value } : m
              ));
            }}
            onRefresh={refreshMembers}
            userRole={userRole}
          />
        </div>
      )}

      {view === 'users' && (
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-3">
              <button onClick={handleBackToMenu} className={`p-2 ${theme.cardHover} rounded-lg transition-colors`}>
                <ArrowLeft className={`w-5 h-5 ${theme.textSecondary}`} />
              </button>
              <h2 className={`text-lg font-medium ${theme.text}`}>Yöneticiler</h2>
            </div>
            {userRole === 'super_user' && (
              <button onClick={handleAddUserClick} className="flex items-center gap-2 px-3 py-2 bg-violet-600 hover:bg-violet-700 text-white text-sm rounded-lg transition-colors">
                <UserPlus className="w-4 h-4" /> Ekle
              </button>
            )}
          </div>
          <UsersList userRole={userRole} darkMode={darkMode} theme={theme} />
        </div>
      )}

      {view === 'addUser' && (
        <div className="max-w-md mx-auto">
          <div className="flex items-center gap-3 mb-4">
            <button onClick={handleViewUsersClick} className={`p-2 ${theme.cardHover} rounded-lg transition-colors`}>
              <ArrowLeft className={`w-5 h-5 ${theme.textSecondary}`} />
            </button>
            <h2 className={`text-lg font-medium ${theme.text}`}>Yeni Yönetici</h2>
          </div>
          <AddUserForm onSuccess={() => setView('users')} onCancel={handleViewUsersClick} darkMode={darkMode} theme={theme} />
        </div>
      )}

      {view === 'addMember' && (
        <div className="max-w-2xl mx-auto">
          <div className="flex items-center gap-3 mb-4">
            <button onClick={handleViewMembersClick} className={`p-2 ${theme.cardHover} rounded-lg transition-colors`}>
              <ArrowLeft className={`w-5 h-5 ${theme.textSecondary}`} />
            </button>
            <h2 className={`text-lg font-medium ${theme.text}`}>Yeni Üye Ekle</h2>
          </div>
          <AddMemberForm onSuccess={handleViewMembersClick} onCancel={handleViewMembersClick} userRole={userRole} darkMode={darkMode} theme={theme} />
        </div>
      )}

      {view === 'pastEvents' && (
        <div className="max-w-4xl mx-auto">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-3">
              <button onClick={handleBackToMenu} className={`p-2 ${theme.cardHover} rounded-lg transition-colors`}>
                <ArrowLeft className={`w-5 h-5 ${theme.textSecondary}`} />
              </button>
              <h2 className={`text-lg font-medium ${theme.text}`}>Geçmiş Etkinlikler</h2>
            </div>
            <button onClick={handleAddPastEventClick} className="flex items-center gap-2 px-3 py-2 bg-violet-600 hover:bg-violet-700 text-white text-sm rounded-lg transition-colors">
              <Plus className="w-4 h-4" /> Ekle
            </button>
          </div>
          <PastEventsList events={pastEvents} onDelete={handleDeletePastEvent} onRefresh={handleViewPastEventsClick} darkMode={darkMode} theme={theme} />
        </div>
      )}

      {view === 'addPastEvent' && (
        <div className="max-w-2xl mx-auto">
          <div className="flex items-center gap-3 mb-4">
            <button onClick={handleViewPastEventsClick} className={`p-2 ${theme.cardHover} rounded-lg transition-colors`}>
              <ArrowLeft className={`w-5 h-5 ${theme.textSecondary}`} />
            </button>
            <h2 className={`text-lg font-medium ${theme.text}`}>Yeni Etkinlik</h2>
          </div>
          <AddPastEventForm onSuccess={handleViewPastEventsClick} onCancel={handleViewPastEventsClick} darkMode={darkMode} theme={theme} />
        </div>
      )}
    </div>
  );
}

function AddUserForm({ onSuccess, onCancel, darkMode, theme }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!username.trim() || !password.trim()) { setError('Tüm alanları doldurun'); return; }
    if (password.length < 6) { setError('Şifre en az 6 karakter olmalı'); return; }
    setLoading(true);
    try {
      const response = await fetch(API_URL + '/api/users', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
        body: JSON.stringify({ username: username.trim(), password }),
      });
      if (!response.ok) { const data = await response.json(); throw new Error(data.error || 'Kullanıcı eklenemedi'); }
      onSuccess();
    } catch (err) { setError(err.message); } finally { setLoading(false); }
  };

  return (
    <form onSubmit={handleSubmit} className={`${theme.card} border ${theme.border} rounded-xl p-6 space-y-4 shadow-sm`}>
      <div>
        <label className={`block text-xs ${theme.textMuted} mb-1.5`}>Kullanıcı Adı</label>
        <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} className={`w-full px-3 py-2 ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-gray-50 border-gray-200'} border rounded-lg ${theme.text} text-sm focus:outline-none focus:border-violet-500 transition-colors`} placeholder="ornek_kullanici" />
      </div>
      <div>
        <label className={`block text-xs ${theme.textMuted} mb-1.5`}>Şifre</label>
        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={`w-full px-3 py-2 ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-gray-50 border-gray-200'} border rounded-lg ${theme.text} text-sm focus:outline-none focus:border-violet-500 transition-colors`} placeholder="••••••••" />
      </div>
      {error && <p className="text-red-500 text-xs">{error}</p>}
      <div className="flex gap-3 pt-2">
        <button type="submit" disabled={loading} className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-violet-600 hover:bg-violet-700 disabled:opacity-50 text-white text-sm rounded-lg transition-colors">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <UserPlus className="w-4 h-4" />} Ekle
        </button>
        <button type="button" onClick={onCancel} className={`px-4 py-2 ${darkMode ? 'bg-gray-800 hover:bg-gray-700 text-gray-300' : 'bg-gray-100 hover:bg-gray-200 text-gray-600'} text-sm rounded-lg transition-colors`}>İptal</button>
      </div>
    </form>
  );
}

// Üye Ekleme Formu (Admin için)
function AddMemberForm({ onSuccess, onCancel, userRole, darkMode, theme }) {
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    email: '',
    department: '',
    class: '',
    schoolNumber: ''
  });
  const [noEmail, setNoEmail] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Mevcut kullanıcı adını al
  const currentUsername = (() => {
    try {
      const token = localStorage.getItem('token');
      if (token) {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.username || 'Yönetici';
      }
    } catch { }
    return 'Yönetici';
  })();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validasyon
    if (!formData.fullName.trim()) { setError('Ad Soyad zorunludur'); return; }
    if (!formData.phone.trim()) { setError('Telefon zorunludur'); return; }
    if (!noEmail && !formData.email.trim()) { setError('E-posta zorunludur veya "Yok" seçeneğini işaretleyin'); return; }
    if (!formData.department.trim()) { setError('Bölüm zorunludur'); return; }
    if (!formData.class.trim()) { setError('Sınıf zorunludur'); return; }
    if (!formData.schoolNumber.trim()) { setError('Okul numarası zorunludur'); return; }

    setLoading(true);
    try {
      const submitData = {
        ...formData,
        email: noEmail ? 'belirtilmedi@acm.local' : formData.email.trim(),
        referral: `${currentUsername} tarafından eklendi`
      };

      const response = await fetch(API_URL + '/api/members', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(submitData)
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.error || 'Üye eklenemedi');
      }
      onSuccess();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const formFields = [
    { name: 'fullName', label: 'Ad Soyad', icon: User, type: 'text', required: true, placeholder: 'Adı ve soyadı' },
    { name: 'phone', label: 'Telefon', icon: Phone, type: 'tel', required: true, placeholder: '05XX XXX XX XX' },
    { name: 'department', label: 'Bölüm', icon: Building, type: 'text', required: true, placeholder: 'Örn: Bilgisayar Mühendisliği' },
    { name: 'class', label: 'Sınıf', icon: GraduationCap, type: 'text', required: true, placeholder: 'Örn: 2' },
    { name: 'schoolNumber', label: 'Okul Numarası', icon: Hash, type: 'text', required: true, placeholder: 'Okul numarası' },
  ];

  const inputClass = `w-full px-3 py-2 ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-gray-50 border-gray-200'} border rounded-lg ${theme.text} text-sm focus:outline-none focus:border-emerald-500 transition-colors`;

  return (
    <form onSubmit={handleSubmit} className={`${theme.card} border ${theme.border} rounded-xl p-6 space-y-4 shadow-sm`}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {formFields.map((field) => {
          const IconComponent = field.icon;
          return (
            <div key={field.name}>
              <label className={`flex items-center gap-2 text-xs ${theme.textMuted} mb-1.5`}>
                <IconComponent className="w-3 h-3" />
                {field.label} {field.required && <span className="text-red-500">*</span>}
              </label>
              <input
                type={field.type}
                name={field.name}
                value={formData[field.name]}
                onChange={handleChange}
                placeholder={field.placeholder}
                className={inputClass}
              />
            </div>
          );
        })}

        {/* E-posta alanı */}
        <div>
          <label className={`flex items-center gap-2 text-xs ${theme.textMuted} mb-1.5`}>
            <Mail className="w-3 h-3" />
            E-posta {!noEmail && <span className="text-red-500">*</span>}
          </label>
          <div className="flex gap-2">
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder={noEmail ? 'Belirtilmedi' : 'ornek@email.com'}
              disabled={noEmail}
              className={`flex-1 px-3 py-2 ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-gray-50 border-gray-200'} border rounded-lg ${theme.text} text-sm focus:outline-none focus:border-emerald-500 transition-colors ${noEmail ? 'opacity-50 cursor-not-allowed' : ''}`}
            />
            <label className={`flex items-center gap-2 px-3 py-2 ${darkMode ? 'bg-gray-800 border-gray-700 hover:border-gray-600' : 'bg-gray-50 border-gray-200 hover:border-gray-300'} border rounded-lg cursor-pointer transition-colors`}>
              <input
                type="checkbox"
                checked={noEmail}
                onChange={(e) => {
                  setNoEmail(e.target.checked);
                  if (e.target.checked) setFormData({ ...formData, email: '' });
                }}
                className="w-4 h-4 rounded bg-gray-700 border-gray-600 text-emerald-500 focus:ring-emerald-500"
              />
              <span className={`text-xs ${theme.textMuted} whitespace-nowrap`}>Yok</span>
            </label>
          </div>
        </div>
      </div>

      {/* Bizi nereden duydunuz - Disabled */}
      <div>
        <label className={`flex items-center gap-2 text-xs ${theme.textMuted} mb-1.5`}>
          <Info className="w-3 h-3" />
          Kayıt Notu
        </label>
        <input
          type="text"
          value={userRole === 'super_user' ? `${currentUsername} tarafından eklendi` : 'Yönetici tarafından kaydedildi'}
          disabled
          className={`w-full px-3 py-2 ${darkMode ? 'bg-gray-800/50 border-gray-700/50 text-gray-500' : 'bg-gray-100 border-gray-200 text-gray-400'} border rounded-lg text-sm cursor-not-allowed`}
        />
      </div>

      {error && (
        <div className="flex items-center gap-2 p-3 bg-red-500/10 border border-red-500/30 rounded-lg text-red-500 text-sm">
          <AlertCircle className="w-4 h-4 flex-shrink-0" />
          {error}
        </div>
      )}

      <div className="flex gap-3 pt-2">
        <button
          type="submit"
          disabled={loading}
          className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-50 text-white text-sm rounded-lg transition-colors"
        >
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <UserPlus className="w-4 h-4" />}
          Üye Ekle
        </button>
        <button
          type="button"
          onClick={onCancel}
          className={`px-4 py-2 ${darkMode ? 'bg-gray-800 hover:bg-gray-700 text-gray-300' : 'bg-gray-100 hover:bg-gray-200 text-gray-600'} text-sm rounded-lg transition-colors`}
        >
          İptal
        </button>
      </div>
    </form>
  );
}

// Geçmiş Etkinlikler Listesi
function PastEventsList({ events, onDelete, darkMode, theme }) {
  if (events.length === 0) {
    return (
      <div className={`${theme.card} border ${theme.border} rounded-xl p-8 text-center shadow-sm`}>
        <Calendar className={`w-12 h-12 ${theme.textMuted} mx-auto mb-3`} />
        <p className={theme.textSecondary}>Henüz geçmiş etkinlik eklenmemiş.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {events.map(event => (
        <div key={event.id} className={`${theme.card} border ${theme.border} rounded-xl p-4 shadow-sm`}>
          <div className="flex items-start justify-between gap-4">
            <div className="flex items-center gap-3">
              <div className={`w-12 h-12 rounded-lg bg-gradient-to-br ${event.color} flex items-center justify-center text-2xl`}>
                {event.icon}
              </div>
              <div>
                <h3 className={`${theme.text} font-medium`}>{event.title}</h3>
                <p className={`${theme.textMuted} text-sm`}>{event.description}</p>
                <p className={`${theme.textMuted} text-xs mt-1`}>{new Date(event.date).toLocaleDateString('tr-TR')}</p>
              </div>
            </div>
            <button onClick={() => onDelete(event.id)} className={`p-2 hover:bg-red-500/20 rounded-lg transition-colors ${theme.textMuted} hover:text-red-500`}>
              <Trash2 className="w-4 h-4" />
            </button>
          </div>

          {event.images && event.images.length > 0 && (
            <div className="mt-4 grid grid-cols-4 gap-2">
              {event.images.map((img, idx) => (
                <div key={idx} className={`aspect-video rounded overflow-hidden ${darkMode ? 'bg-gray-800' : 'bg-gray-100'}`}>
                  <img src={img.src} alt={img.alt} className="w-full h-full object-cover" />
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

// Geçmiş Etkinlik Ekleme Formu
function AddPastEventForm({ onSuccess, onCancel, darkMode, theme }) {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [icon, setIcon] = useState('Rocket');
  const [color, setColor] = useState('from-blue-500 to-cyan-500');
  const [customColor, setCustomColor] = useState('#8b5cf6');
  const [useCustomColor, setUseCustomColor] = useState(false);
  const [images, setImages] = useState([{ src: '', alt: '' }]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [iconSearch, setIconSearch] = useState('');
  const [showAllIcons, setShowAllIcons] = useState(false);

  const inputClass = `w-full px-3 py-2 ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-gray-50 border-gray-200'} border rounded-lg ${theme.text} text-sm focus:outline-none focus:border-violet-500 transition-colors`;

  // Tüm Lucide İkonları
  const allIcons = {
    // Popüler
    Rocket, Star, Heart, Zap, Trophy, Award, Target, Crown, Gem, Diamond, Flame, Sparkles, Gift,
    // İletişim
    MessageCircle, MessageSquare, Mail, Phone, Video, Mic, Headphones, Send, Share2, Bell,
    // Medya
    Camera, Film, Music, Play, Pause, Volume2, Image, Youtube, Twitch, Instagram, Twitter,
    // Teknoloji
    Code, Code2, Terminal, Database, Server, Cloud, Cpu: Computer, Laptop, Smartphone, Monitor, Wifi,
    Globe, Globe2, Link, QrCode, Usb, Bluetooth, Radio,
    // Eğitim
    GraduationCap, Book, BookOpen, Library, Newspaper, FileText: FileTextIcon, Pencil, Highlighter,
    // İş
    Briefcase, Building, Building2, Store, ShoppingCart, CreditCard, Wallet, DollarSign, Euro,
    PieChart, BarChart, TrendingUp, Presentation, Calculator,
    // Ulaşım
    Car, Plane, Ship, Truck, Navigation, MapPin, Map, Compass, Fuel,
    // Doğa
    Sun, Moon, Sunrise, Sunset, Cloud: CloudRain, Snowflake, Wind, Umbrella, Leaf, TreePine, Mountain, Waves,
    // Yiyecek
    Coffee, Pizza, Cake, IceCream, Wine, Utensils,
    // Spor & Oyun
    Gamepad, Gamepad2, Dice1, Dice5, Target: Target, Trophy: Trophy, Medal,
    // Araçlar
    Wrench, Hammer, Scissors, Paintbrush, Palette, PenTool, Wand2, Key, Lock, Unlock,
    // Sağlık
    Heart: Heart, Activity, Thermometer, TestTube, Pill: Tablet,
    // Sosyal
    Users, User, UserPlus, UserCheck, Contact, PersonStanding,
    // UI
    Menu, Search, Settings: Cog, Filter, Layout, Grid: LayoutGrid, List, Layers, Sidebar,
    // Oklar & Yönler
    ArrowUp, ArrowDown, ArrowLeft, ArrowRight, ChevronUp, ChevronDown, ChevronLeft, ChevronRight,
    // Durumlar
    Check, CheckCircle, X: XCircle, AlertCircle, AlertTriangle, Info, HelpCircle, Ban: XOctagon,
    // Diğer Popüler
    Calendar, Clock, Timer, Hourglass, History, RefreshCw, Download, Upload, Save: SaveIcon, Trash2,
    Eye, EyeOff, Bookmark, Pin, Flag, Tag, Hash, AtSign, Percent, Infinity,
    Power, Plug, Battery, Lightbulb, Flashlight, Lamp, Siren,
    Shield: ShieldIcon, ShieldCheck, Sword, Swords, Skull, Ghost,
    Smile, Meh, Frown, ThumbsUp, ThumbsDown,
    Home, Tent, Anchor, Compass: Compass, Rocket: Rocket, Plane: Plane, Globe: Globe
  };

  // İkon arama/filtreleme
  const filteredIcons = Object.entries(allIcons).filter(([name]) =>
    name.toLowerCase().includes(iconSearch.toLowerCase())
  );

  const displayedIcons = showAllIcons ? filteredIcons : filteredIcons.slice(0, 40);

  // Genişletilmiş Renk Paleti
  const colorOptions = [
    // Temel Renkler
    { name: 'Mavi', value: 'from-blue-500 to-cyan-500' },
    { name: 'Mor', value: 'from-purple-500 to-pink-500' },
    { name: 'Yeşil', value: 'from-green-500 to-emerald-500' },
    { name: 'Turuncu', value: 'from-orange-500 to-amber-500' },
    { name: 'Kırmızı', value: 'from-red-500 to-rose-500' },
    // Ek Renkler
    { name: 'İndigo', value: 'from-indigo-500 to-purple-500' },
    { name: 'Pembe', value: 'from-pink-500 to-rose-500' },
    { name: 'Turkuaz', value: 'from-teal-500 to-cyan-500' },
    { name: 'Lime', value: 'from-lime-500 to-green-500' },
    { name: 'Sarı', value: 'from-yellow-500 to-orange-500' },
    { name: 'Gri', value: 'from-gray-500 to-slate-500' },
    { name: 'Gökyüzü', value: 'from-sky-500 to-blue-500' },
    { name: 'Menekşe', value: 'from-violet-500 to-purple-500' },
    { name: 'Fuşya', value: 'from-fuchsia-500 to-pink-500' },
    { name: 'Gül', value: 'from-rose-500 to-red-500' },
    // Gradient Kombinasyonları
    { name: 'Gün Batımı', value: 'from-orange-500 via-red-500 to-pink-500' },
    { name: 'Okyanus', value: 'from-blue-500 via-cyan-500 to-teal-500' },
    { name: 'Orman', value: 'from-green-600 via-emerald-500 to-teal-500' },
    { name: 'Ateş', value: 'from-yellow-500 via-orange-500 to-red-500' },
    { name: 'Galaksi', value: 'from-purple-600 via-violet-500 to-indigo-500' },
    { name: 'Altın', value: 'from-yellow-400 via-amber-500 to-orange-500' },
    { name: 'Gece', value: 'from-slate-800 via-gray-700 to-zinc-600' },
    { name: 'Neon', value: 'from-green-400 via-cyan-500 to-blue-500' },
    { name: 'Şeker', value: 'from-pink-400 via-purple-500 to-indigo-500' },
    { name: 'Retro', value: 'from-amber-500 via-orange-600 to-red-600' },
  ];

  const addImageField = () => setImages([...images, { src: '', alt: '' }]);
  const removeImageField = (index) => setImages(images.filter((_, i) => i !== index));
  const updateImage = (index, field, value) => {
    const newImages = [...images];
    newImages[index][field] = value;
    setImages(newImages);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!title.trim() || !description.trim()) { setError('Başlık ve açıklama zorunludur'); return; }

    const validImages = images.filter(img => img.src.trim());
    const finalColor = useCustomColor ? `bg-[${customColor}]` : color;

    setLoading(true);
    try {
      const response = await fetch(API_URL + '/api/past-events', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          title: title.trim(),
          description: description.trim(),
          icon,
          color: finalColor,
          images: validImages
        }),
      });
      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.error || 'Etkinlik eklenemedi');
      }
      onSuccess();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // İkon bileşenini render et
  const renderIcon = (iconName, size = 'w-5 h-5') => {
    const IconComponent = allIcons[iconName];
    if (IconComponent) {
      return <IconComponent className={size} />;
    }
    return <Star className={size} />;
  };

  return (
    <form onSubmit={handleSubmit} className={`${theme.card} border ${theme.border} rounded-xl p-6 space-y-4 shadow-sm`}>
      {/* Başlık */}
      <div>
        <label className={`block text-xs ${theme.textMuted} mb-1.5`}>Etkinlik Başlığı</label>
        <input
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className={inputClass}
          placeholder="Örn: ACMen Talks #5"
        />
      </div>

      {/* Açıklama */}
      <div>
        <label className={`block text-xs ${theme.textMuted} mb-1.5`}>Açıklama</label>
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className={`${inputClass} resize-none`}
          rows={3}
          placeholder="Etkinlik hakkında kısa açıklama..."
        />
      </div>

      {/* İkon Seçimi */}
      <div>
        <label className={`block text-xs ${theme.textMuted} mb-1.5`}>İkon</label>
        <input
          type="text"
          value={iconSearch}
          onChange={(e) => setIconSearch(e.target.value)}
          className={`${inputClass} mb-2`}
          placeholder="İkon ara... (örn: rocket, star, heart)"
        />
        <div className={`flex flex-wrap gap-2 max-h-48 overflow-y-auto p-2 ${darkMode ? 'bg-gray-800/50' : 'bg-gray-100'} rounded-lg`}>
          {displayedIcons.map(([name, IconComponent]) => (
            <button
              type="button"
              key={name}
              onClick={() => setIcon(name)}
              title={name}
              className={`w-10 h-10 rounded-lg flex items-center justify-center transition-all ${icon === name ? 'bg-violet-600 ring-2 ring-violet-400 text-white' : `${darkMode ? 'bg-gray-800 hover:bg-gray-700 text-gray-300' : 'bg-white hover:bg-gray-50 text-gray-600'}`}`}
            >
              <IconComponent className="w-5 h-5" />
            </button>
          ))}
        </div>
        {filteredIcons.length > 40 && !showAllIcons && (
          <button
            type="button"
            onClick={() => setShowAllIcons(true)}
            className="mt-2 text-xs text-violet-500 hover:text-violet-400"
          >
            + {filteredIcons.length - 40} daha fazla ikon göster
          </button>
        )}
        {showAllIcons && (
          <button
            type="button"
            onClick={() => setShowAllIcons(false)}
            className={`mt-2 text-xs ${theme.textMuted} hover:${theme.textSecondary}`}
          >
            Daha az göster
          </button>
        )}
        <p className={`text-xs ${theme.textMuted} mt-1`}>Seçili: {icon}</p>
      </div>

      {/* Renk Seçimi */}
      <div>
        <label className={`block text-xs ${theme.textMuted} mb-1.5`}>Renk</label>

        {/* Hazır Renkler */}
        <div className="flex flex-wrap gap-2 mb-3">
          {colorOptions.map(c => (
            <button
              type="button"
              key={c.value}
              onClick={() => { setColor(c.value); setUseCustomColor(false); }}
              title={c.name}
              className={`w-8 h-8 rounded-lg transition-all ${!useCustomColor && color === c.value ? `ring-2 ring-violet-400 ring-offset-2 ${darkMode ? 'ring-offset-gray-900' : 'ring-offset-white'}` : ''} bg-gradient-to-br ${c.value}`}
            />
          ))}
        </div>

        {/* Özel Renk Seçici */}
        <div className={`flex items-center gap-3 p-3 ${darkMode ? 'bg-gray-800/50' : 'bg-gray-100'} rounded-lg`}>
          <label className={`flex items-center gap-2 text-xs ${theme.textMuted} cursor-pointer`}>
            <input
              type="checkbox"
              checked={useCustomColor}
              onChange={(e) => setUseCustomColor(e.target.checked)}
              className="w-4 h-4 rounded bg-gray-700 border-gray-600 text-violet-500 focus:ring-violet-500"
            />
            Özel Renk
          </label>
          {useCustomColor && (
            <div className="flex items-center gap-2">
              <input
                type="color"
                value={customColor}
                onChange={(e) => setCustomColor(e.target.value)}
                className="w-8 h-8 rounded cursor-pointer bg-transparent border-0"
              />
              <span className={`text-xs ${theme.textMuted}`}>{customColor}</span>
            </div>
          )}
        </div>
      </div>

      {/* Önizleme */}
      <div>
        <label className={`block text-xs ${theme.textMuted} mb-1.5`}>Önizleme</label>
        <div className={`flex items-center gap-3 p-3 ${darkMode ? 'bg-gray-800/50' : 'bg-gray-100'} rounded-lg`}>
          <div
            className={`w-14 h-14 rounded-xl flex items-center justify-center text-white ${useCustomColor ? '' : `bg-gradient-to-br ${color}`}`}
            style={useCustomColor ? { backgroundColor: customColor } : {}}
          >
            {renderIcon(icon, 'w-7 h-7')}
          </div>
          <div>
            <p className={`${theme.text} font-medium`}>{title || 'Etkinlik Başlığı'}</p>
            <p className={`${theme.textMuted} text-sm`}>{description || 'Etkinlik açıklaması...'}</p>
          </div>
        </div>
      </div>

      {/* Resimler */}
      <div>
        <label className={`block text-xs ${theme.textMuted} mb-1.5`}>Etkinlik Resimleri</label>
        <div className="space-y-3">
          {images.map((img, index) => (
            <div key={index} className={`p-3 ${darkMode ? 'bg-gray-800/50' : 'bg-gray-100'} rounded-lg space-y-2`}>
              <div className="flex gap-2">
                <input
                  type="url"
                  value={img.src}
                  onChange={(e) => updateImage(index, 'src', e.target.value)}
                  className={`flex-1 px-3 py-2 ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border rounded-lg ${theme.text} text-sm focus:outline-none focus:border-violet-500 transition-colors`}
                  placeholder="Resim URL'si"
                />
                <input
                  type="text"
                  value={img.alt}
                  onChange={(e) => updateImage(index, 'alt', e.target.value)}
                  className={`w-32 px-3 py-2 ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border rounded-lg ${theme.text} text-sm focus:outline-none focus:border-violet-500 transition-colors`}
                  placeholder="Alt metin"
                />
                {images.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removeImageField(index)}
                    className={`p-2 ${darkMode ? 'bg-gray-800 hover:bg-red-500/20' : 'bg-white hover:bg-red-50'} rounded-lg transition-colors ${theme.textMuted} hover:text-red-500`}
                  >
                    <X className="w-4 h-4" />
                  </button>
                )}
              </div>
              {/* Resim Önizleme */}
              {img.src && (
                <div className="relative">
                  <img
                    src={img.src}
                    alt={img.alt || 'Önizleme'}
                    className={`w-full max-h-48 object-cover rounded-lg border ${darkMode ? 'border-gray-700' : 'border-gray-200'}`}
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                    onLoad={(e) => {
                      e.target.style.display = 'block';
                      if (e.target.nextSibling) e.target.nextSibling.style.display = 'none';
                    }}
                  />
                  <div className={`hidden items-center justify-center w-full h-32 ${darkMode ? 'bg-gray-800 border-gray-700' : 'bg-gray-100 border-gray-200'} rounded-lg border ${theme.textMuted} text-sm`}>
                    <AlertCircle className="w-4 h-4 mr-2" /> Resim yüklenemedi
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
        <button
          type="button"
          onClick={addImageField}
          className="mt-2 flex items-center gap-1 text-xs text-violet-500 hover:text-violet-400"
        >
          <Plus className="w-3 h-3" /> Resim Ekle
        </button>
      </div>

      {error && <p className="text-red-500 text-xs">{error}</p>}

      <div className="flex gap-3 pt-2">
        <button
          type="submit"
          disabled={loading}
          className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-violet-600 hover:bg-violet-700 disabled:opacity-50 text-white text-sm rounded-lg transition-colors"
        >
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Kaydet
        </button>
        <button
          type="button"
          onClick={onCancel}
          className={`px-4 py-2 ${darkMode ? 'bg-gray-800 hover:bg-gray-700 text-gray-300' : 'bg-gray-100 hover:bg-gray-200 text-gray-600'} text-sm rounded-lg transition-colors`}
        >
          İptal
        </button>
      </div>
    </form>
  );
}

export default AdminPanel;
